import React, { Component } from 'react'
import { object } from 'prop-types'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import Modal from 'bisu-react-modal'

import Side from './side'
import FormPreset from './form-preset'
import { fetchPresets, savePreset, deletePreset } from './actions'

class FeesPresets extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openForm: false,
      item: null,
    }
  }

  _openForm = (preset) => {
    const item = Map.isMap(preset) ? preset : null
    this.setState({
      openForm: true,
      item,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
    })
  }

  _onSubmit = (payload) => {
    const { dispatch } = this.props
    dispatch(savePreset(payload))
      .then((res) => {
        if (!res.error) {
          this._closeForm()
        }
      })
  }

  _onDelete = (item) => {
    const { dispatch } = this.props
    dispatch(deletePreset(item.get('id')))
      .then((res) => {
        if (!res.error) {
          this._closeForm()
          this.context.router.replace('/fees-presets')
        }
      })
  }

  _renderForm() {
    const { openForm, item } = this.state
    const { __pending } = this.props
    return (
      <Modal isOpen={openForm} handleClose={this._closeForm}>
        <FormPreset
          pending={__pending}
          item={item}
          onSubmit={this._onSubmit}
          onDelete={this._onDelete}
        />
      </Modal>
    )
  }

  render() {
    const { children, __list } = this.props

    return (
      <div className="row">
        <div className="col-sm-3">
          {this._renderForm()}
          <Side onForm={this._openForm} list={__list} />
        </div>
        <div className="col-sm-9">
          {React.cloneElement(children, { onForm: this._openForm })}
        </div>
      </div>
    )
  }
}

FeesPresets.onEnter = (store) => () => store.dispatch(fetchPresets())

FeesPresets.contextTypes = {
  router: object,
}

function mapStateToProps(state) {
  return {
    __pending: state.preset.get('pending'),
    __list: state.preset.get('list'),
  }
}

export default connect(mapStateToProps)(FeesPresets)



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/index.js